<template>
  <d-row>
    <d-col cols="12" lg="9">
      <d-card class="mb-4 card-small">
        <!-- Card Header -->
        <d-card-header class="border-bottom">
          <d-row class="align-items-center">
            <d-col cols="12" lg="6">
              <h6 class="m-0">
                {{ $t('cryptogramGenerator.card.title') }}
              </h6>
            </d-col>
          </d-row>
        </d-card-header>

        <d-list-group flush>
          <d-list-group-item class="p-3" v-if="cryptogram">
            <cryptogram-form ref="cryptogram_form" />
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <d-col cols="12" lg="3">
      <!-- Sidebar Widgets -->
      <sidebar-actions :model="cryptogram" @save="save" />
    </d-col>
  </d-row>
</template>

<script>
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import CryptogramForm from './CryptogramForm.vue';
import SidebarActions from './SidebarActions.vue';
import { _LOAD_MODEL_, MODEL } from './CryptogramModel';

export default {
  name: 'cryptogram-page',
  components: {
    CryptogramForm,
    SidebarActions,
  },
  data() {
    return {};
  },
  computed: {
    cryptogram() {
      const { cryptogram } = this.$store.state.cryptogramGenerator;
      if (cryptogram) {
        Events.$emit(_LOAD_MODEL_, cryptogram);
        return cryptogram;
      }
      return cloneDeep(MODEL);
    },
  },
  methods: {
    save() {
      this.$refs.cryptogram_form.save();
    },
  },
};
</script>
